











































































































































































































































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Maintenancejob, Property, Fee, Invoice } from "@/models";
import ProgressButton from "@/components/ProgressButton.vue";
import "devextreme/dist/css/dx.light.css";
import { DxDateBox } from "devextreme-vue/date-box";

@Component({
  components: {
    DxDateBox,
    ProgressButton,
  },
})
export default class InvoicePage extends Vue {
  @Mutation("app/removeRequest")
  public removeRequest: (id: string) => void;
  @Getter("maintenancejobs/hasUnsavedChanges")
  public hasUnsavedChanges: boolean;
  @Prop({ default: false }) public showsidebar: boolean;
  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];
  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;
  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;
  @Mutation("maintenancejobs/addUnsavedChange")
  public addUnsavedChange: (id: string) => Promise<any>;
  @Action("maintenancejobs/updateMaintenancejob")
  public updateMaintenancejob: (maintenancejob: Maintenancejob) => Promise<any>;
  @Action("maintenancejobs/generateMaintenancejobPdf")
  generateMaintenancejobPdf: (payload: {
    maintenancejob: Maintenancejob;
    downloadType: string;
  }) => Promise<any>;
  public async mounted() {
    setTimeout(() => {
      if (this.fees.length === 0) {
        this.setMaintenancejobDeep({
          path: "invoice.fees",
          data: [new Fee()],
        });
      }
    }, 1000);
    this.allCalculation();
  }

  get fees() {
    return this.maintenancejob.invoice.fees;
  }
  set fees(data: Fee[]) {
    this.setMaintenancejobDeep({
      path: "invoice.fees",
      data,
    });
  }

  public addressPreviewLine1() {
    return `${this.addressLine1}${
      this.addressLine2 ? `, ${this.addressLine2}` : ""
    }`;
  }
  public addressPreviewLine2() {
    return `${this.addressPostcode}`;
  }

  get addressPostcode() {
    return this.maintenancejob.address.postcode;
  }
  set addressPostcode(data) {
    this.setMaintenancejobDeep({ path: "address.postcode", data });
  }

  get addressLine1() {
    return this.maintenancejob.address.line1;
  }
  set addressLine1(data) {
    this.setMaintenancejobDeep({ path: "address.line1", data });
  }

  get addressLine2() {
    return this.maintenancejob.address.line2;
  }
  set addressLine2(data) {
    this.setMaintenancejobDeep({ path: "address.line2", data });
  }

  get invoicedate() {
    return this.maintenancejob.invoice.invdate;
  }
  set invoicedate(data) {
    this.setMaintenancejobDeep({ path: "invoice.invdate", data });
  }
  get invid() {
    return this.maintenancejob.invoice.invid;
  }
  set invid(data) {
    this.setMaintenancejobDeep({ path: "invoice.invid", data });
  }
  get invfor() {
    return this.maintenancejob.invoice.invfor;
  }
  set invfor(data) {
    this.setMaintenancejobDeep({ path: "invoice.invfor", data });
  }
  get description() {
    return this.maintenancejob.invoice.description;
  }
  set description(data) {
    this.setMaintenancejobDeep({ path: "invoice.description", data });
  }
  public canSave() {
    let result = true;
    if (
      !this.maintenancejob.address.line1 ||
      !this.maintenancejob.address.postcode ||
      !this.maintenancejob.defectid
    )
      result = false;
    return result;
  }
  public isSaving: boolean = false;
  public saveAll() {
    this.isSaving = true;
    this.updateMaintenancejob(this.maintenancejob).then(() => {
      this.isSaving = false;
      this.$toasted.success("Saved");
      this.$router.push("/invoices");
    });
  }

  public cancel() {
    this.setCurrent(new Maintenancejob());
    this.$router.push("/invoices");
  }
  isNumber(event: any) {
    const keyCode = event.keyCode || event.which;
    const inputChar = String.fromCharCode(keyCode);

    if (!/^\d*\.?\d{0,2}$/.test(event.target.value + inputChar)) {
      event.preventDefault();
    }
  }
  async onPaste(event: any) {
    // Prevent pasting non-numeric values
    event.preventDefault();

    try {
      const clipboardData = await navigator.clipboard.readText();

      if (!/^\d*\.?\d{0,2}$/.test(clipboardData)) {
        // You can add your handling logic here (e.g., show an error message)
      } else {
        // Replace the input value with the pasted data
        event.target.value = clipboardData;
      }
    } catch (error) {
      console.error("Failed to read clipboard data:", error);
    }
  }

  public addNewFee(): void {
    this.maintenancejob.invoice.fees = this.maintenancejob.invoice.fees.concat([
      new Fee(),
    ]);
  }
  public deletefeeindex: number = -1;
  public showDeleteDialog(index: number) {
    this.deletefeeindex = index;
    this.removeFee();
  }
  public removeFee(): void {
    this.maintenancejob.invoice.fees = this.$onecentral.removeItemByIndex(
      this.maintenancejob.invoice.fees,
      this.deletefeeindex
    );
  }
  calculateTotal(fee: Fee, index: number) {
    this.setMaintenancejobDeep({
      path: `invoice.fees[${index}].amount`,
      data: fee.unitprice,
    });
  }
  public subTotal: number = 0;
  public totalTax: number = 0;
  public mainTotal: number = 0;
  public async allCalculation() {
    this.subTotal = 0; // Initialize subTotal to 0
    if (
      this.maintenancejob.invoice.fees.length != 0 &&
      this.maintenancejob.invoice.fees[0].unitprice != ""
    ) {
      const grandTotal = this.maintenancejob.invoice.fees.reduce(
        (accumulator, currentItem) => {
          // Calculate the total for the current item (rate * qty)
          const itemTotal = parseFloat(currentItem.unitprice);

          // Add the current item's total to the accumulator
          return accumulator + itemTotal;
        },
        0
      ); // 0 is the initial accumulator value
      this.subTotal = grandTotal;
      let taxpercent =
        this.maintenancejob.quotation.taxrate == ""
          ? 0
          : +this.maintenancejob.quotation.taxrate;

      this.totalTax = (this.subTotal * taxpercent) / 100;
      this.mainTotal = this.subTotal + this.totalTax;
    }
  }
  /**
   * Download Maintenancejob/Invoice/Proforma PDF
   *
   * @param {Maintenancejob} maintenancejob
   * @param {String} downloadType
   */
  public generatePdf(
    maintenancejob: Maintenancejob,
    downloadType: string,
    requestId: string
  ): void {
    this.generateMaintenancejobPdf({ maintenancejob, downloadType })
      .then((key: string) => {
        this.$onecentral.downloadAttachment(key);
        this.$toasted.success(
          `${downloadType} for ${maintenancejob.ref} PDF downloaded`
        );
      })
      .finally(() => this.removeRequest(requestId))
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
